import { nanoid } from 'nanoid';
import { useContext } from 'react';
import { IDS_TOAST_CONTAINER_ID } from './store';
import { ToasterStoreContext } from './ToasterStoreContext';
import { ADD_TOAST } from '../Types/toastTypes';
export const useToaster = toasterOptions => {
  const context = useContext(ToasterStoreContext);
  if (!context) {
    throw new Error('ToasterStoreContext is not provided');
  }

  /**
   * Creates a new toast and dispatches it to the toast container.
   *
   * @param {string} title - The title of the toast.
   * @param {string} message - The message content of the toast.
   * @param {ToastClickEvent} onClick - The callback function to be called when the toast is clicked.
   * @param {ToastImage} image - The image to be displayed in the toast.
   * @param {ToastOptions} [options] - Optional additional options for the toast. The options object includes the id and the data-testid
   */
  const toast = (title, message, onClick, image, options) => {
    const newToastId = nanoid();
    const action = {
      type: ADD_TOAST,
      entry: {
        title,
        toastId: newToastId,
        containerId: IDS_TOAST_CONTAINER_ID,
        onClick,
        message,
        image,
        dataTestId: options?.['data-testid'],
        id: options?.id,
        timeStamp: Date.now(),
        useParentContainer: Boolean(toasterOptions?.useParentContainer),
        host: toasterOptions?.host,
        serializedImage: options?.serializedImage,
        originToastId: options?.originToastId,
        originContainerId: options?.originContainerId,
        source: options?.source,
        origin: options?.origin
      }
    };
    context.dispatch(action);
    return newToastId;
  };
  return {
    toast
  };
};